function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.203 16.4V6.8h-8v9.6h8zm-3.2-8h1.6v6.4h-1.6V8.4zm-3.2 0h1.6v6.4h-1.6V8.4zm0-4.8h4.8v1.6h-4.8V3.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.602 16.4c0 .882.718 1.6 1.6 1.6h8c.883 0 1.6-.718 1.6-1.6V6.8h1.6V5.2h-3.2V3.6c0-.882-.717-1.6-1.6-1.6h-4.8c-.882 0-1.6.718-1.6 1.6v1.6h-3.2v1.6h1.6v9.6zm3.2-12.8h4.8v1.6h-4.8V3.6zm-.8 3.2h7.2l.001 9.6h-8V6.8h.8z",
  fill: "#FA2727",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.802 8.4h1.6v6.4h-1.6V8.4zm3.2 0h1.6v6.4h-1.6V8.4z",
  fill: "#FA2727",
  fillRule: "nonzero"
}));

var SvgDeleteIcon = function SvgDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-icon.c8355f7c.svg";
export { ForwardRef as ReactComponent };